import Vue from 'vue'
import App from './App.vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import momentTimeZone from 'moment-timezone'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './plugins/bootstrap-vue'
import './plugins/confirmModal'
import './plugins/toast'
import './style/global.scss'
import Vuelidate from 'vuelidate'
import './plugins/fontawesome'
import './style/index.css'

import * as Sentry from "@sentry/vue";
import settings from "../settings";
import DebugPlugin from './utils/debugUtils'

Vue.config.productionTip = false

Vue.use(DebugPlugin)
Vue.use(Vuelidate)
Vue.use(VueMoment, { moment })
momentTimeZone.tz.setDefault('America/Santiago')

if (settings.SENTRY_DSN) {
  console.log("Init Sentry");
  Sentry.init({
    Vue,
    dsn: settings.SENTRY_DSN,
    dataCollection: {
      // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
      // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
      // userInfo: false,
      // httpBodies: []
    }
  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
